import { render, staticRenderFns } from "./mCustomer.vue?vue&type=template&id=073bb6e8&scoped=true"
import script from "./mCustomer.vue?vue&type=script&lang=js"
export * from "./mCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073bb6e8",
  null
  
)

export default component.exports